












import { routerStore } from "@/store/routerStore";
import Icon from "./Icon.vue";
import {
  onMounted,
  watch,
  defineComponent,
  computed
} from "@vue/composition-api";

export default defineComponent({
  name: "TitleBar",
  components: {
    Icon
  },
  setup(props, { root }) {
    return {
      title: computed(()=> routerStore.pwd.split("/").slice(-1)[0])
    }
  }
});
